import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'wz-error-viewer',
  templateUrl: './error-viewer.component.html',
  styleUrls: ['./error-viewer.component.scss'],
  standalone: false,
})
export class ErrorViewerComponent implements OnInit {
  @Input()
  matIcon!: string;

  constructor() {}

  ngOnInit() {}
}
